import Card from "../UI/Card";
import ExpenseFilter from "./ExpenseFilter";
import styles from "./Expenses.module.css";
import ExpenseList from "./ExpenseList";

const Expenses = (props) => {
  const { expenseData } = props;

  const changeFilteredYearHandler = (
    filteredYear
  ) => {
    props.onChangeFilterYear(filteredYear);
  };
  return (
    <Card className={styles["expenses"]}>
      <ExpenseFilter
        onChangeFilterYear={
          changeFilteredYearHandler
        }
      />
      {expenseData.length > 0 && (
        <ExpenseList expenseData={expenseData} />
      )}
      {expenseData.length === 0 && (
        <p id={styles["not-found"]}>
          No Expense Found
        </p>
      )}
    </Card>
  );
};

export default Expenses;
